import apiClient from "../../config/apiClient";


export const FetchDoctorsWithAppointment = async (period) => {
    const user = window.localStorage.getItem("token");
    const token = user;
     return await apiClient.get(`/public/portal?url=hr/housekeeping/rosters?period=2025-12%26has_appointment=1`, {
        headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
  // /front-desk/appointments?page=1&limit=15&patient_id=27501&startDate=&endDate=